export class ChatEntry {
  body: string;
  time: Date;
  origin: 'self' | 'other';
  originTitle?: string;
  index?: number;
}
